module.exports = __webpack_public_path__ + "5c114213/img/delete-icon.eb7de062.svg";